import type { ActivateSubscription200Data } from './activateSubscription200Data';

/**
 * 공통 API 응답 형식
 */
export type ActivateSubscription200 = {
  /**
   * 응답 데이터
   * @nullable
   */
  data?: ActivateSubscription200Data;
  /** 응답 메시지 */
  message: string;
  /** 요청 성공 여부 */
  success: boolean;
  /** 응답 시간 */
  timestamp?: string;
};
